<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   <div style="text-align:right; margin-top:90px;">
			 <p-button type="info"  @click="goToEntityDocuments()" >
			  <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
					  Document Browser
					  </p-button>      
		  </div>
		  
		  
  
        <h5 style="font-weight:bold;">Create New Folder</h5>
  	   <card>
  	 
  			  <div class="col-sm-7" >    
                 <fg-input type="text"
                  name="new folder name"
				  label="New Folder Name"                  
                  v-model="new_folder_name">
       			 </fg-input>
       			 
       			 	 <p-button type="info"  @click="createFolder()" >
     					 <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
               			Create Folder
              		</p-button>
              
              
            </div>
          </card>  
          <!-- end create new folder -->  
          
          
          
      <h5 style="font-weight:bold;">Create New Tag</h5>
  	   <card>
  	 
  			  <div class="col-sm-7" >    
                 <fg-input type="text"
                  name="new_tag_name"
				  label="New Tag Name"                  
                  v-model="new_tag_name">
       			 </fg-input>
       			 
       			 	 <p-button type="info"  @click="createTag()" >
     					 <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
               			Create Tag
              		</p-button>
              
              
            </div>
          </card>  
          <!-- end create new folder -->  
          
          <div>
         
         
        <div style="margin-top:80px">
        	<h5 style="font-weight:bold;">Your Folders</h5>
 		</div>
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
          
             <el-table :data="folders">
                <el-table-column label="Folder Name" property="folder_name"  width="500" ></el-table-column>
          					
             <el-table-column label="Visiblity" width="200">
            		<template slot-scope="scope">
							<div v-if="!scope.row.public || scope.row.public==1">Public</div>						    					 
    					    <div v-else>Private</div>	
          			</template>
            
             </el-table-column>
             
             <el-table-column label="Edit" width="200">
            		<template slot-scope="scope">
						 <p-button type="success" size="sm" icon @click="goToEditFolder(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
          			</template>
            
             </el-table-column>
             
             
            
            
             </el-table>
          
          	</div>
          </div>
    	</div>


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
       
       if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/documents/get/get_org_folders/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.folders = response.data.folders;
			
			})
      	}//get connected entity info
      
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        variables:[],
        folders:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	task_id:this.$route.params.tid,
    	createForm: true,
    	loadCommon: false,
    	loadInfo: false,
    	new_folder_name:"",
        new_tag_name:"",
    	
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    goToTask(){
       		this.$router.push( '/edit-task/'+ this.task_id + '/entity/'+ this.$route.params.eid)
       },
        goToEntityDocuments(){
      		 this.$router.push( '/entity-documents/'+this.$route.params.eid)  
       },
       
      createFolder(){
	    	if( this.new_folder_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for your new folder.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 		
    	  const vm = this;
       	
			swal({
				title: 'Are you sure?',
				text: 'A new folder will be created for all entities in your organization.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes',
				buttonsStyling: false
			  }).then(function () {
				 const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/documents/create_new_folder/entity/'+vm.$route.params.eid;
			     ApiService.post(uri, {
      				'new_folder_name':vm.new_folder_name,
      		
      				}).then(response => {
					swal({
					  title: 'Done!',
					  text: 'The folder has been created successfully.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
						vm.$router.push( '/entity-documents/'+vm.$route.params.eid)  
				
					})
					//end swal
				})
		 
			
			  })//end swal-then
	    
	    },
	     createTag(){
	    	if( this.new_tag_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for your new tag.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 		
    	  const vm = this;
       	
			swal({
				title: 'Are you sure?',
				text: 'A new tag will be created for all entities in your organization.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes',
				buttonsStyling: false
			  }).then(function () {
				 const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/documents/create_new_tag/entity/'+vm.$route.params.eid;
			     ApiService.post(uri, {
      				'new_tag_name':vm.new_tag_name,
      		
      				}).then(response => {
					swal({
					  title: 'Done!',
					  text: 'The tag has been created successfully.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
						vm.$router.push( '/entity-documents/'+vm.$route.params.eid)  
				
					})
					//end swal
				})
		 
			
			  })//end swal-then
	    
	    },
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
    goToEditFolder(row){
      	 this.$router.push( '/edit-folder/'+row.id+"/entity/"+this.$route.params.eid);
      	 
      },

      editInvoice() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		  	this.model.due_date = this.model.deadline;
  		  	
    		let uri = this.$base_url+'/api/v1/accounting/update/invoice/'+this.$route.params.iid;
      		ApiService.post(uri, this.model).then(response => {
         			this.$router.push( '/view-entity/'+ this.$route.params.eid);
         			
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


